<div class="app-container" dir="rtl">
  <header class="app-header">
    <div class="header-title">شاخص‌ها</div>

    <button class="back-btn" (click)="goBack()">
      <span>بازگشت</span>
      <span class="arrow">←</span>
    </button>
  </header>

  <main class="router-content p-3" style="display: flex; gap: 20px; margin-top: 20px;">
    <aside class="sidebar">
      <ul class="menu-list" style="list-style: none; padding: 0; margin: 0;">
        <li *ngFor="let item of menuItems" class="menu-item" style="margin-bottom: 10px;">
          <a [routerLink]="item.route" 
            routerLinkActive="actives" 
            class="menu-link" 
            style="display: flex; align-items: center; padding: 10px; text-decoration: none; border-radius: 8px; background: #f8f9fa; color: #333;">
            
            <i class="fa {{ item.icon }}" style="margin-left: 10px; font-size: 1.1rem; width: 24px; text-align: center;"></i>
            
            <span>{{ item.label }}</span>
            
          </a>
        </li>
      </ul>
    </aside>

    <section class="content-area" style="flex-grow: 1; background: #fff; border-radius: 8px; border: 1px solid #eee;">
      <router-outlet></router-outlet>
    </section>

  </main>
</div>
